import {RouteLocationNormalized, RouteRecordRaw} from "vue-router";
import AuthLayout from "@/layouts/AuthLayout.vue";
import Login from "@/features/auth/views/Login.vue";

export const authRoutes: RouteRecordRaw = {
  path: '/auth',
  component: AuthLayout,
  meta: {requiresAuth: false},
  children: [
    {
      path: 'login',
      name: 'Login',
      meta: {requiresAuth: false},
      component: Login,
      props: true,
    },
    {
      path: 'change-user',
      name: 'ChangeUser',
      meta: {requiresAuth: false},
      component: () => import('@/features/auth/views/ChangeUser.vue'),
    },
    {
      path: 'forgot-password',
      name: 'ForgotPassword',
      meta: {requiresAuth: false},
      component: () => import('@/features/auth/views/ForgotPassword.vue'),
    },
    {
      path: 'forgot-password-confirmation',
      name: 'ForgotPasswordConfirmation',
      meta: {requiresAuth: false},
      component: () => import('@/features/auth/views/ForgotPasswordConfirmation.vue'),
      props: (route: RouteLocationNormalized) => ({email: route.params.email || ''}),
    }
  ],
};
